import { X } from 'lucide-react';

/**
 * Generic Modal component
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether modal is open
 * @param {Function} props.onClose - Function to close modal
 * @param {React.ReactNode} props.children - Modal content
 * @param {string} props.title - Modal title
 * @param {string} props.badge - Badge text
 * @param {string} props.badgeClass - Badge CSS class
 */
export const Modal = ({ isOpen, onClose, children, title, badge, badgeClass }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 backdrop-blur-sm flex items-center justify-center z-50" style={{ background: 'color-mix(in srgb, var(--bg-deeper) 60%, transparent)' }}>
      <div
        className="rounded-2xl p-6 max-w-lg w-full mx-4 shadow-2xl"
        style={{
          background: 'var(--bg-dim)',
          border: '1px solid var(--border)',
        }}
      >
        <div className="flex justify-between items-start mb-4">
          <div>
            {badge && (
              <div className={`inline-block px-3 py-1 rounded-full text-xs font-medium mb-2 ${badgeClass}`}>
                {badge}
              </div>
            )}
            {title && <h3 className="text-xl font-bold" style={{ color: 'var(--text-primary)', fontFamily: 'var(--font-display)' }}>{title}</h3>}
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-xl transition-colors hover:scale-105"
            style={{ color: 'var(--text-dim)' }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--surface)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <X size={20} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};
